import axios from "axios";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:9000";

const API_BASE_URL = `${BACKEND_URL.replace(/\/$/, "")}/api/rfqs`;

// Liste principale RFQ: utilise la table rfqs.
export const searchRfqs = async (params: any) => {
  const response = await axios.post(`${API_BASE_URL}/search`, params);
  return response.data;
};

export const countRfqs = async (params: any) => {
  const response = await axios.post(`${API_BASE_URL}/search/totalpage`, params);
  return response.data;
};

// À garder séparé: liste des offres fournisseurs sur les RFQ.
export const searchRfqOffers = async (params: any) => {
  const response = await axios.post(`${API_BASE_URL}/search-offers`, params);
  return response.data;
};

export const countRfqOffers = async (params: any) => {
  const response = await axios.post(`${API_BASE_URL}/search-offers/totalpage`, params);
  return response.data;
};
